"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { RuntimeConfig } from "@/lib/runtime-config";

const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);

export function RuntimeConfigProvider({
  value,
  children,
}: Readonly<{
  value: RuntimeConfig;
  children: ReactNode;
}>) {
  return (
    <RuntimeConfigContext.Provider value={value}>
      {children}
    </RuntimeConfigContext.Provider>
  );
}

export function useRuntimeConfig(): RuntimeConfig {
  const cfg = useContext(RuntimeConfigContext);
  if (!cfg) {
    throw new Error(
      "useRuntimeConfig must be used within a RuntimeConfigProvider",
    );
  }
  return cfg;
}
